








import Vue from 'vue';


export default Vue.extend({
  name: 'back-to-the-top',
  methods: {
    scrollBackToTop () {
      window.scrollTo({
        behavior: 'smooth',
        top: 0,
      });
    },

    handleScroll () {
      const backToTheTop = document.querySelector('.back-to-the-top-container')!;
      const className = 'is--scrolling';

      window.addEventListener('scroll', () => {
        if (window.scrollY > 400) {
          backToTheTop.classList.add(className);
          return;
        }

        backToTheTop.classList.remove(className);
      });
    },
  },

  mounted () {
    this.handleScroll();
  },
});
